import React from "react";
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { DownOutlined, LogoutOutlined, SearchOutlined } from '@ant-design/icons';
import { Menu } from 'antd';
import { FormattedMessage  } from 'react-intl';
import { GlobalConfigContext } from '../../components/Config/GlobalConfigContext';
import * as authActions from '../../actions/auth';

//import { allMenu } from '../../utilities/menu';
//const { Sider } = Layout;
const SubMenu = Menu.SubMenu;

// SiderNavigation component
class SideMenu extends React.PureComponent {
	static contextType = GlobalConfigContext;
  	constructor(props) {
		super(props);
		this.state = {
			mode: 'inline',
	        isPopover: false,
	        openKeys: [ 'dashboard' ],
	        selectedKey: 'dashboard'
		}
		  
		this.rootSubmenuKeys = [ ...props.menu.map(item => item.key) ];
		 //console.log(`this.rootSubmenuKeys`, this.rootSubmenuKeys);
	}
    
    componentDidMount() {
        const _path = this.props.path;
        
        //console.log(_path);
        //console.log(_path.substr(0, _path.lastIndexOf('/')));
        
        this.setState({
            //openKeys: _path.substr(0, _path.lastIndexOf('/')),
            selectedKey: _path
        });
    }
    /*menuClick = e => {
        this.setState({
            selectedKey: e.key
        });
    };*/
    openMenu = (openKeys) => {
        //console.log(`openKeys:`, openKeys)
        const latestOpenKey = openKeys.find(key => this.state.openKeys.indexOf(key) === -1);
		/*this.setState({
			openKeys: latestOpenKey ? [latestOpenKey] : [],
		});*/

		if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			this.setState({ openKeys });
		} else {
			this.setState({
				openKeys: latestOpenKey ? [latestOpenKey] : [],
			});
		}
	};
	logout = (value) => {
		this.props.dispatch(authActions.logout());
		const { history } = this.props;
		history.push('/');
	}  
    /*handleSelect = (item) => {
	    console.log(`item`, item);
	    if(this.rootSubmenuKeys.includes(item.key.replace('/', ''))){
		    this.setState({
				openKeys: item.key ? [item.key] : [],
			});
		}
    }*/
	render() {
		const { isMobile, isTablet, activeProperty } = this.context;
		const { drawer, menu } = this.props;
		const extraClass = isTablet?'is-tablet':'';

		// const activeProperty = localStorage.activeProperty ? JSON.parse(localStorage.activeProperty) : null;
		// console.log(`activeProperty:`, activeProperty.location_country)
		
		let navigation = menu.filter(item => (
				item.roles
				? item.roles.includes((this.context.user && this.context.user.role) || null) 
				: true) 
			&& (item.requires
				? item.requires.some(r => (activeProperty && activeProperty.settings && activeProperty.settings[r])) 
				: true)
            && (item.countries && item.countries.length ? item.countries.includes(activeProperty && activeProperty.location_country) : true) 
        );
		if(/* isTablet &&  */!drawer){
			navigation = navigation.filter(item => item.isPrimary === true);
		}
		//console.log(`this.state.openKeys:`, this.state.openKeys)
		return (
            <div className={`main-navigation ${extraClass} `} >
		    <Menu
			    theme={this.context.theme}
				//selectedKeys={[this.state.selectedKey]}
				defaultOpenKeys={['dashboard']}
		      	openKeys={this.state.openKeys}
		    	//onClick={this.menuClick}
		      	onOpenChange={this.openMenu}
		      	//onSelect={this.handleSelect}
				className="mainNavigation"
				mode={this.props.mode}
				inlineIndent={11}
				//triggerSubMenuAction="hover"
				>
		    {
		      navigation.map((subMenu) => {
				// const topChildren = subMenu.children && subMenu.children.filter(child => (
				// 	!(child.navigation === false) && (child.roles ? child.roles.includes(this.context.user.role) : true))
				// );
				const topChildren = subMenu.children && subMenu.children.filter(child => (
					!(child.navigation === false) && this.context.ability.can('navigate', child.key) && (child.roles ? child.roles.includes((this.context.user && this.context.user.role) || null) : true) )
				).filter(child => child.countries && child.countries.length ? child.countries.includes(activeProperty && activeProperty.location_country) : true);
                // console.log(`topChildren:`, topChildren)
		        if (topChildren && topChildren.length) {
		          return (
                      <SubMenu disabled={subMenu.disabled || false} key={`${subMenu.key}`} title={<span>{subMenu.icon}{((subMenu.showText === undefined || subMenu.showText) || isMobile || drawer )?<span>{subMenu.name}</span>:null} {!isMobile && !drawer && <DownOutlined style={{ fontSize: "10px" }} />}</span>} className={(subMenu.showText === false && !isMobile && !drawer)?'icon-only':null}>
                        {topChildren.map(menu => {
                              const innerChildren = menu.children && menu.children.filter(child => !(child.navigation === false) && this.context.ability.can('navigate', menu.key));
                              //console.log(`innerChildren:`, innerChildren, menu.name)
                              if(innerChildren && innerChildren.length){
                                  return (
                                      <SubMenu disabled={menu.disabled || false} key={`${menu.key}`} title={<span>{((menu.showText === undefined || menu.showText) || isMobile || drawer )?<span>{menu.name}</span>:null} {!isMobile && !drawer && <DownOutlined style={{ fontSize: "10px" }} />}</span>} className={(menu.showText === false && !isMobile && !drawer)?'icon-only':null}>
                                          {innerChildren.filter(item => !(item.navigation === false) && this.context.ability.can('navigate', item.key)).map(menuitem => {
                                              //console.log(`menuitem:`, menuitem.key, this.context.ability.can('navigate', menuitem.key));
                                              return (<Menu.Item disabled={menuitem.disabled || false} key={`${menuitem.key}`} onClick={this.props.closeDrawer}><Link to={`${menuitem.url}`}>{menuitem.name}</Link></Menu.Item>)
                                          })}
                                      </SubMenu>
                                  );
                              }else{
                                  return (<Menu.Item disabled={menu.disabled || false} key={`${menu.key}`} onClick={this.props.closeDrawer}><Link to={`${menu.url}`}>{menu.name}</Link></Menu.Item>)
                              }

                          })}
                      </SubMenu>
                  );
                }
                if(this.context.ability.can('navigate', subMenu.key)){
                    return (
                        <Menu.Item key={`${subMenu.key}`} className={(subMenu.showText === false && !isMobile && !drawer) ? 'icon-only' : null} onClick={this.props.closeDrawer}>
                            <Link to={`${subMenu.url}`}>
                                {subMenu.icon}{((subMenu.showText === undefined || subMenu.showText) || isMobile || drawer )?<span>{subMenu.name}</span>:null}
                            </Link>
                        </Menu.Item>
                    );
                }else{
                    return null;
                }
		      })
		    }
		    {(isTablet && !drawer)?
		       	<Menu.Item key="navigation-search" className="icon-only" selectable={false}><SearchOutlined
                    style={{ fontSize:"18px", top:"3px", position:"relative", fontWeight:600 }} /></Menu.Item>
		        :null
			}

			
			{ /* isMobile && <Menu.Item key='logout' className={(!isMobile && !drawer) ? 'icon-only' : null} selectable={false}>
				<span onClick={this.logout}>
					<LogoutOutlined className="main-icon" />{( isMobile || drawer )?<span><FormattedMessage id="layout.profile.sign-out" defaultMessage={`Sign Out`} /></span>:null}
						</span>
		</Menu.Item> */}


		    {/*drawer?
		    <Menu.ItemGroup title="Profile">
			    <Menu.Item key="11"><Link to={"/"}><Icon type="home"/> <span>Profile</span></Link></Menu.Item>
				<Menu.Item key="21"><Link to={"/account"}><Icon type="setting"/><span>Settings</span></Link></Menu.Item>
				<Menu.Item key="51"><a onClick={this.logout}><Icon type="logout"/><span>Sign Out</span></a></Menu.Item>
			</Menu.ItemGroup>
			:null*/}


		    </Menu>
		</div>
        );
	}
}
SideMenu.propTypes = {
	path: PropTypes.string.isRequired
}

const mapDispatchToProps = dispatch => ({
	authActions: bindActionCreators(authActions, dispatch),
	dispatch
})

export default connect(null, mapDispatchToProps)(SideMenu);